<template>
    <div class="certification" >
        <div class="title-bar" v-show="isShow">
            <img src="//images.jinku.com/newjk/org/images/personal/personal_01.jpg" alt="" style="width: .19rem;height: .34rem;" v-on:click="goback">
            <strong style="font-size: .36rem;">实名认证</strong>
        </div>
        <div class="attestation">
            <div class="import">
                <span>真实姓名</span><input type="text" placeholder="" v-model.trim="trueName">
            </div>
            <div class="import" >
                <span>证件类型</span>
                <van-dropdown-menu>
                  <van-dropdown-item v-model="cardType" :options="cardTypeOption" />
                </van-dropdown-menu>
            </div>
            <div class="import">
                <span>证件号码</span><input type="text" placeholder="" v-model.trim="cardNo">
            </div>
            <p class="err" style="width: 6.07rem;margin: auto;color: red;" v-if="errShow">{{errMsg}}</p>
        </div>
        <div style="width: 100%;text-align: center;margin-top: .7rem;">
            <button class="lon" v-show="this.showSaveBtn" v-on:click="saveIdentity">保存</button>
        </div>
    </div>
</template>

<script>
    import http from "../../lib/http";
    import Vue from 'vue';
    import { DropdownMenu, DropdownItem } from 'vant';
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    export default{
        name:'certification',
        data(){
            return{
                showPage:false,
                cardType: 1,
                cardTypeOption: [
                    { text: '身份证',   value: 1 },
                    { text: '护照', value: 2 },
                    { text: '军官证', value: 3 },
                    { text: '台胞证', value: 4 },
                    { text: '港澳通行证', value: 5 },
                  ],
                trueName:'',
                cardNo:'',
                showSaveBtn:false,
                // repet:false,
                errShow:false,
                errMsg:'',
				isShow:true
            }
        },
        methods:{
            getIdentityInfo:function () {
                let that = this;
                http({
                    method: "post",
                    url: "/org/user/get-user-identity",
                    data: ""
                }).then(function(res){
                    if(res.code == 0){
                        if (Object.keys(res.data).length == 0){
                            that.showSaveBtn = true;
                        }else{
                            that.trueName = res.data.user_real;
                            that.cardType = parseInt(res.data.card_type);
                            that.cardNo = res.data.user_card;
                        }
                    }
                }).catch(function(err){

                });
            },
            saveIdentity:function () {
                let that = this;
                if (this.trueName == '' || this.cardNo ==''){
                    this.errMsg = '请填写真实信息';
                    this.errShow = true;
                    return false;
                }
                http({
                    method: "post",
                    url: "/user/upd-profile",
                    data: "user_real="+this.trueName+'&card_type='+this.cardType+'&user_card='+this.cardNo
                }).then(function(res){
                    if(res.code == 0){
                        alert("实名完成");
                        that.showSaveBtn = false;
                    }else {
                        that.errMsg = res.mess;
                        that.errShow = true;
                        return false;
                    }
                }).catch(function(err){

                });
            },
            goback:function () {
                this.$router.push('/personal');
            },

        },
        created(){
            this.getIdentityInfo();
			if (navigator.userAgent.indexOf(';wealthmanagement-android') != -1) {
			    this.isShow = false;
			} else if (navigator.userAgent.indexOf(';wealthmanagement-iOS') != -1) {
			    this.isShow = false;
			}
        },
    }
</script>

<style scoped>
    .title-bar {
        position: relative;
        text-align: center;
        margin-top: .36rem;
        margin-bottom: .27rem;
        padding-bottom: .3rem;
        border-bottom: .01rem solid #E6E6E6;
    }

    .title-bar img,
    .title-bar strong {
        vertical-align: middle;
    }

    .title-bar img {
        position: absolute;
        left: .3rem;
        top: 20%;
    }
    .attestation{
        width: 100%;
    }
    .import{
        width: 6.07rem;
        height: .99rem;
        display: flex;
        align-items: center;
        margin: auto;
        font-size: .26rem;
        border-bottom: .01rem solid #E6E6E6;

    }
    .import span{
        padding-right: .6rem;
        font-weight: bold;
    }
    .import input{
        border: none;
        border-left: .01rem solid #E6E6E6;
        padding-left: .3rem;
        color: #333333;
    }
    .lon{
        width: 6.06rem;
        height: .78rem;
        color: white;
        font-size: .28rem;
        line-height: .78rem;
        text-align: center;
        background: #087AFE;
        border-radius: .03rem;
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/personal/certification.vue